import React, { createContext, memo, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

import Header from '../Header/Header';
import Sidebar from '../App/Sidebar';
import ErrorBoundary from '../Common/ErrorBoundary';
import { useDashboardData } from '../Dashboard/useDashboardData';

const drawerWidth = 220;
const closedWidth = 80;

const useStyles = makeStyles(theme => ({
  toolbarSpacer: theme.mixins.toolbar,
  root: {
    display: 'flex',
    height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`,
    overflow: 'hidden',
  },

  main: {
    flexGrow: 1,
    overflow: 'auto',
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  mainShift: {
    marginLeft: drawerWidth,
  },
}));

export const DashboardContext = createContext<any>({});
export const AppContent = memo(({ initialLoad }: { initialLoad: boolean }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const dashboardData = useDashboardData();
  const handleToggle = () => setOpen(prev => !prev);
  return (
    <DashboardContext.Provider value={dashboardData}>
      <Header />
      <div className={classes.root}>
        <Sidebar open={open} onToggle={handleToggle} />

        <main className={clsx(classes.main, open && classes.mainShift)}>
          {!initialLoad && (
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          )}
        </main>
      </div>
    </DashboardContext.Provider>
  );
});

AppContent.displayName = 'AppContent';